/**
 * @flow
 */

import styled from 'react-emotion'
import colors from '../../../themes/Colors'
import { Typo24TwilightBlueBNI } from '../../../themes/Fonts/Nort'

export const SkewComponentContainer = styled('div')`
  margin-left: 10px;
  background-color: ${colors.whiteTwo};
  box-shadow: 0 0.25em 0.5em 0 ${colors.black10};
  padding: 1px 0.8em 1px 0.254em;
  transform: skewX(-25deg);
  display: inline-block;
  @media (min-width: 320px) and (max-width: 767px) {
    transform: skewX(-15deg);
    padding: 0.286em 0.714em;
    box-shadow: 0 0.286em 0.571em 0 ${colors.black10};
  }
`

export const SkewText = styled(Typo24TwilightBlueBNI)`
  transform: skewX(25deg);
  display: block;
  padding-left: 5px;
  @media (min-width: 320px) and (max-width: 767px) {
    transform: skewX(15deg);
    font-weight: normal;
    font-size: 1.143em;
  }
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/SkewComponent/styledComponents.js